var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHouseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 49,
    viewBox: "0 0 53 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57237 21.6336L1.57236 21.6336L1.57046 21.6352C1.14146 21.9916 0.971381 22.5807 1.1656 23.1148C1.35591 23.644 1.85841 23.9969 2.41917 23.9969H7.05053V47.0659C7.05053 47.8025 7.64731 48.3993 8.38388 48.3993L44.7723 48.4013C45.5089 48.4013 46.1057 47.8046 46.1057 47.068V23.9969H50.7536C51.3152 23.9969 51.8199 23.6448 52.0082 23.1122C52.1973 22.5829 52.0344 21.9901 51.5976 21.6329C51.5974 21.6328 51.5973 21.6326 51.5971 21.6325L27.4265 1.76583C27.4261 1.76553 27.4258 1.76522 27.4254 1.76492C26.9334 1.35748 26.2229 1.3592 25.7308 1.76475L1.57237 21.6336ZM26.5787 4.51852L47.0313 21.33H44.7727H44.4028L44.3847 21.3892C43.8371 21.5551 43.4387 22.0636 43.4387 22.6654V45.7344H35.3762V29.2842C35.3762 28.5476 34.7794 27.9509 34.0429 27.9508C34.0428 27.9508 34.0428 27.9508 34.0428 27.9508L19.1301 27.9487H19.13C18.3934 27.9487 17.7966 28.5455 17.7966 29.2821V45.7323H9.71752V22.6633C9.71752 21.9267 9.12074 21.33 8.38417 21.33H6.13953L26.5787 4.51852ZM32.7092 45.7346H20.4631V30.6175H32.7092V45.7346Z",
    fill: "#1A405F",
    stroke: "#1A405F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHouseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/HouseIcon.0b117776.svg";
export { ForwardRef as ReactComponent };